import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import IMAGES from "@/data/images";

const services = [
  {
    title: "Rénovation complète",
    imageKey: "renovation-couloir-appartement",
    text: "Appartement, maison ou local professionnel : nous gérons la rénovation intégrale de vos espaces, du gros \u0153uvre jusqu'aux finitions. Démolition, cloisonnement, redistribution des espaces — notre équipe assure la cohérence du chantier à chaque étape.",
  },
  {
    title: "Electricité",
    imageKey: "amenagement-bureaux-verriere",
    text: "Mise aux normes, création ou modification d'installation électrique, tableaux, prises, éclairage encastré. Nous intervenons sur les installations neuves comme sur la rénovation de l'existant.",
  },
  {
    title: "Plomberie & Sanitaires",
    imageKey: "pose-mosaique-douche-italienne",
    text: "Installation et remplacement de salles de bain, douches à l'italienne, vasques, robinetterie. Raccordement eau chaude/froide, évacuations, mise aux normes. Nous concevons des espaces fonctionnels et soignés.",
  },
  {
    title: "Carrelage & Sols",
    imageKey: "cuisine-equipee-carrelage-ciment",
    text: "Pose de carrelage, carreaux de ciment, mosaïque, terrazzo et parquet. Nous maîtrisons les poses complexes : chevron, point de Hongrie, motifs géométriques. Chaque pose fait l'objet d'une préparation rigoureuse du support.",
  },
  {
    title: "Menuiserie & Aménagement sur mesure",
    imageKey: "bibliotheque-sur-mesure-bois",
    text: "Placards intégrés, dressings, bibliothèques, mezzanines, verrières, cloisons, gardes-corps. Nous concevons et réalisons des aménagements sur mesure adaptés à vos espaces et à votre usage.",
  },
  {
    title: "Peinture & Finitions",
    imageKey: "placards-suspendus-mur-accent-bleu",
    text: "Peinture intérieure, décoration murale, enduits décoratifs. Nous apportons le soin du détail à chaque finition : ragréage, joints, plinthes, baguettes d'angle. Un chantier bien fini, c'est notre signature.",
  },
  {
    title: "Maçonnerie",
    imageKey: "renovation-entree-escalier-helicoidal",
    text: "Ouvertures dans les murs porteurs, création de trémies, ragréage, reprises de fissures. Nous intervenons en coordination avec les bureaux d'études lorsque les travaux le nécessitent.",
  },
];

export default function Services() {
  return (
    <>
      <SEO
        title="Nos services — Electricité, Plomberie, Carrelage, Menuiserie, Peinture | Bati Rui Paris"
        description="Bati Rui intervient sur tous les corps de métier : électricité, plomberie, carrelage, menuiserie, peinture, maçonnerie. Paris et Ile-de-France. Devis gratuit."
        canonical="https://www.batirui.com/services"
      />

      {/* Introduction */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-[#F8F6F2]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1
            data-testid="services-h1"
            className="font-heading text-4xl sm:text-5xl font-black text-[#1B2E4B] tracking-tight"
          >
            Nos prestations — Tous corps d'état
          </h1>
          <p className="mt-6 text-[#3D3D3A] text-base sm:text-lg leading-relaxed max-w-3xl">
            Bati Rui intervient sur l'ensemble des corps de métier du bâtiment.
            Particuliers, bailleurs, entreprises : nous prenons en charge votre
            chantier de A à Z, avec une coordination complète et un interlocuteur unique.
          </p>
        </div>
      </section>

      {/* Services blocks */}
      {services.map((service, index) => (
        <section
          key={service.title}
          data-testid={`service-block-${index}`}
          className={index % 2 === 0 ? "bg-[#F8F6F2]" : "bg-[#EEECE8]"}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
            <div
              className={`flex flex-col ${
                index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
              } gap-8 md:gap-16 items-center`}
            >
              {/* Image */}
              <div className="w-full lg:w-1/2">
                <div className="overflow-hidden rounded-md">
                  <img
                    src={IMAGES[service.imageKey].url}
                    alt={IMAGES[service.imageKey].alt}
                    className="w-full h-72 md:h-96 object-cover"
                    loading="lazy"
                  />
                </div>
              </div>

              {/* Text */}
              <div className="w-full lg:w-1/2">
                <h3 className="font-heading text-xl sm:text-2xl font-semibold text-[#1B2E4B] mb-4">
                  {service.title}
                </h3>
                <p className="text-[#3D3D3A] text-base leading-relaxed">
                  {service.text}
                </p>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section className="py-20 md:py-32 bg-[#1B2E4B]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight">
            Votre projet ne rentre pas dans une case ?
          </h2>
          <p className="mt-4 text-white/80 text-base sm:text-lg">
            Décrivez-le nous.
          </p>
          <Link
            to="/contact"
            data-testid="services-cta-devis"
            className="inline-block mt-10 bg-[#C0392B] hover:bg-[#a02f23] text-white rounded-md px-8 py-4 text-base font-medium transition-colors"
          >
            Demander un devis gratuit
          </Link>
        </div>
      </section>
    </>
  );
}
